import { observer } from 'mobx-react'
import { LegalText } from 'components/DigitalAccountCheck/IntroText/LegalText'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { getFooterSeals } from 'components/Footer/getSeals'
import Seals from 'components/Footer/Seals'

const DacFooterWrapperFfgRceEdit = observer(() => {
  const {
    rootStore: {
      traversal: { dacWidgetStep },
      navigation: { currentPageInSession }
    }
  } = useRootStore()

  const isDacPage =
    currentPageInSession && currentPageInSession?.indexOf('dac') > -1

  return (
    <>
      <Seals seals={getFooterSeals()} itemMargin={16} />
      {isDacPage && dacWidgetStep === 'BANK_LOGIN_STEP' && <LegalText />}
    </>
  )
})

export { DacFooterWrapperFfgRceEdit }
